<div class="dx-card wide-card">
    <h4 class="content-block ap-green">User Role Maintenance</h4>
    <h6 class="content-block" style="color: red;">To add or delete users from roles, please click on the 'Go to Security Groups' button and update the  user security group. Kindly note the updates could take up to 15 minutes to be reflected on this page.</h6>
    <dx-data-grid class="fixGridHeight" id="UserRolesGrid" [dataSource]="userRoleList" [showRowLines]="true"
        [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true"
        keyExpr="apexId">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" type="default" text="Export to Excel" (onClick)="exportExcel($event)">
                </dx-button>
                <dx-button type="default" text="Go To Security Groups" (onClick)="goToIam()">
                </dx-button>
                <dx-button type="default" text="Refresh" (onClick)="refreshGrid()">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
        <dxi-column dataField="apexId" caption="ApexId" [width]="120"></dxi-column>
        <dxi-column dataField="userName" caption="Full Name" [width]="200"></dxi-column>
        <dxi-column dataField="isIGAdmin" caption="IG Admin" [width]="130"></dxi-column>
        <dxi-column dataField="isIGPower" caption="IG Power User" [width]="130"></dxi-column>
        <dxi-column dataField="isIGAmerica" caption="IG America" [width]="130"></dxi-column>
        <dxi-column dataField="isIGEurope" caption="IG Europe" [width]="130"></dxi-column>
        <dxi-column dataField="isIGAsia" caption="IG Asia" [width]="130"></dxi-column>
        <dxi-column dataField="isTGEEAdmin" caption="TGEE Admin" [width]="130"></dxi-column>
        <dxi-column dataField="isTGEEPower" caption="TGEE Power User" [width]="130"></dxi-column>
        <dxi-column dataField="isTGEEViewer" caption="TGEE Viewer" [width]="130"></dxi-column>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>